'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vuex = require('vuex');

var _vuex2 = _interopRequireDefault(_vuex);

var _questions = require('./data/questions');

var _questions2 = _interopRequireDefault(_questions);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
  state: {
    questions: _questions2.default,
    answers: (0, _functional.range)(5).map(function () {
      return [];
    }),
    activeSlideIndex: 0,
    finalAnswer: 'pitta',
    quizFinished: false
  },
  actions: {
    finishQuiz: function finishQuiz(_ref) {
      var commit = _ref.commit,
          state = _ref.state;

      return new Promise(function (resolve, reject) {
        var finalAnswer = void 0;
        var question2AnswerDosha = state.answers[1][0].value;
        var question3AnswerIsBalanced = state.answers[2].some(function (answer) {
          return answer.label === 'Balanced – it’s oily at the roots and dry at the ends';
        });

        if (question2AnswerDosha === 'Pitta') {
          finalAnswer = 'pitta';

          commit('setFinalAnswer', finalAnswer);
        }

        if (question2AnswerDosha === 'Vata') {
          finalAnswer = 'vata';

          var pittaShouldOverrule = state.answers[2].some(function (answer) {
            return answer.label === 'Thicker - it feels fine and sparse' || answer.label === 'Fuller – it lacks volume';
          });

          if (pittaShouldOverrule) {
            finalAnswer = 'pitta';
          }
        }

        if (question2AnswerDosha === 'Kapha') {
          var answersToChangeToVata = ['Silkier – it feels rough and unruly', 'Smoother – it frizzes easily', 'Healthier – it’s damaged and lacks shine'];
          var question4AnswerLabels = state.answers[2].map(convertAnswerToJustLabels);
          var question3ShouldChangeThisToVata = answersToChangeToVata.every(function (val) {
            return question4AnswerLabels.includes(val);
          });

          if (question3ShouldChangeThisToVata && question3AnswerIsBalanced === false) {
            finalAnswer = 'vata';
          } else {
            finalAnswer = 'kapha';
          }
        }

        if (question3AnswerIsBalanced && question2AnswerDosha !== 'Pitta') {
          finalAnswer = 'kapha';
        }

        var question3AnswerShouldForceVata = state.answers[2].map(convertAnswerToJustLabels).find(function (answer) {
          return answer === 'Manageable – it’s naturally curly';
        });

        if (question3AnswerShouldForceVata) {
          finalAnswer = 'vata';
        }

        if (state.answers[1].some(function (answer) {
          return answer.label === 'Silk – fine texture';
        }) && (state.answers[2].some(function (answer) {
          return answer.label === 'Balanced – it’s oily at the roots and dry at the ends';
        }) || state.answers[3].some(function (answer) {
          return answer.label === 'Oily';
        }))) {
          finalAnswer = 'kapha';
        }

        commit('setFinalAnswer', finalAnswer);
        commit('finishQuiz', true);

        return resolve();
      });
    }
  },
  mutations: {
    setActiveSlideIndex: function setActiveSlideIndex(state, index) {
      state.activeSlideIndex = index;
    },
    setFinalAnswer: function setFinalAnswer(state, answer) {
      state.finalAnswer = answer;
    },
    removeFirstAnswer: function removeFirstAnswer(state, _ref2) {
      var index = _ref2.index,
          answer = _ref2.answer;

      state.answers[index] = state.answers[index].slice(1);

      var questionIndex = state.questions[index].answers.findIndex(function (x) {
        return x.label === answer.label;
      });
      state.questions[index].answers[questionIndex].checked = false;
    },
    setAnswer: function setAnswer(state, _ref3) {
      var index = _ref3.index,
          answer = _ref3.answer;

      var question = state.questions[index];
      var questionAnswers = state.answers[index];
      var alreadyInAnswers = questionAnswers.includes(answer);

      if (alreadyInAnswers) {
        questionAnswers.splice(questionAnswers.findIndex(function (answeredQuestion) {
          return answeredQuestion === answer;
        }), 1);
      } else {
        questionAnswers.push(answer);
      }

      question.answers.map(function (x) {
        return x.checked = questionAnswers.map(function (z) {
          return z.label;
        }).includes(x.label);
      });
    },
    finishQuiz: function finishQuiz(state, val) {
      state.quizFinished = val;
    }
  },

  getters: {
    questions: function questions(state) {
      return state.questions;
    },
    answersFor: function answersFor(state) {
      return function (index) {
        return state.answers[index];
      };
    },
    finalAnswer: function finalAnswer(state) {
      return state.finalAnswer;
    },
    activeSlideIndex: function activeSlideIndex(state) {
      return state.activeSlideIndex;
    },
    quizFinished: function quizFinished(state) {
      return state.quizFinished;
    }
  }
});


function convertAnswerToJustLabels(answer) {
  return answer.label;
}